module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-dialog', {
    attrs: {
      "title": "信息披露",
      "append-to-body": "",
      "close-on-click-modal": false,
      "visible": _vm.dialogVisible,
      "width": "800px"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      },
      "before-close": _vm.close
    }
  }, [_c('div', {
    staticClass: "center-box",
    staticStyle: {
      "height": "60vh",
      "overflow-y": "auto",
      "overflow-x": "hidden",
      "padding": "0 30px"
    }
  }, [_c('div', [_c('div', {
    staticClass: "title-text",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("八戒小贷信息披露")]), _c('div', {
    staticClass: "title-text"
  }, [_vm._v("尊敬的客户：")]), _c('div', {
    staticClass: "title-text"
  }, [_vm._v("     感谢您关注和选择重庆市猪八戒宜创小额贷款有限公司（下称“八戒小贷”）的信贷服务！为了维护您的权益，请您详细阅读本信息披露。")]), _c('div', {
    staticClass: "title-text"
  }, [_vm._v("一、八戒小贷公司的基本信息")]), _c('div', {
    staticClass: "title-content"
  }, [_vm._v("    重庆市猪八戒宜创小额贷款有限公司成立于2016-05-31，股东是重庆猪八戒金融服务有限公司（持股100%），经营场所位于：重庆市渝北区金开大道西段106号2幢8层3号，暂无分支机构。")]), _c('div', {
    staticClass: "title-content",
    staticStyle: {
      "margin": "15px 0"
    }
  }, [_vm._v("1.1 营业执照")]), _c('div', {
    staticClass: "center-box"
  }, [_c('img', {
    attrs: {
      "src": require("./img/789456412.png"),
      "alt": ""
    }
  })]), _c('div', {
    staticClass: "title-content",
    staticStyle: {
      "margin": "15px 0"
    }
  }, [_vm._v("1.2 开业批复")]), _c('div', {
    staticClass: "center-box"
  }, [_c('img', {
    attrs: {
      "src": require("./img/189798458.png"),
      "alt": ""
    }
  })]), _c('div', {
    staticClass: "center-box"
  }, [_c('img', {
    attrs: {
      "src": require("./img/287894455.png"),
      "alt": ""
    }
  })]), _c('div', {
    staticClass: "title-content",
    staticStyle: {
      "margin": "15px 0"
    }
  }, [_vm._v("1.3 董监高信息")]), _c('div', [_c('el-table', {
    staticStyle: {
      "color": "#333"
    },
    attrs: {
      "data": _vm.tableData1,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "index",
      "label": "序号",
      "align": "center",
      "width": "60"
    }
  }), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "姓名",
      "width": "120"
    }
  }), _c('el-table-column', {
    attrs: {
      "prop": "service",
      "label": "职务"
    }
  })], 1)], 1), _c('div', {
    staticClass: "title-content",
    staticStyle: {
      "margin": "15px 0"
    }
  }, [_vm._v("1.4 变更信息")]), _c('div', [_c('el-table', {
    staticStyle: {
      "color": "#333"
    },
    attrs: {
      "data": _vm.tableData2,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "index",
      "label": "序号",
      "align": "center",
      "width": "60"
    }
  }), _c('el-table-column', {
    attrs: {
      "prop": "data1",
      "label": "变更日期",
      "width": "100"
    }
  }), _c('el-table-column', {
    attrs: {
      "prop": "data2",
      "label": "变更项目"
    }
  }), _c('el-table-column', {
    attrs: {
      "prop": "data3",
      "label": "变更前",
      "width": "135"
    }
  }), _c('el-table-column', {
    attrs: {
      "prop": "data4",
      "label": "变更后",
      "width": "135"
    }
  })], 1)], 1), _c('div', {
    staticClass: "title-text",
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_vm._v("二、八戒小贷业务介绍")]), _c('div', {
    staticClass: "title-content"
  }, [_vm._v("2.1 互联网渠道")]), _c('div', {
    staticClass: "title-content"
  }, [_vm._v("官网："), _c('a', {
    attrs: {
      "href": "https://www.jr-zbj.com",
      "target": "_blank"
    }
  }, [_vm._v("www.jr-zbj.com")]), _vm._v("，ICP备案号：渝ICP备2025066797号-1；")]), _c('div', {
    staticClass: "title-content"
  }, [_vm._v("微信小程序：戒易花，ICP备案号：渝ICP备18007804号-9X。")]), _c('div', {
    staticClass: "title-content",
    staticStyle: {
      "margin": "15px 0"
    }
  }, [_vm._v("2.2 产品信息")]), _c('div', [_c('el-table', {
    staticStyle: {
      "color": "#333"
    },
    attrs: {
      "data": _vm.tableData3,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "data1",
      "label": "产品名称",
      "width": "135"
    }
  }), _c('el-table-column', {
    attrs: {
      "prop": "data2",
      "label": "戒易花"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "table_text"
        }, [_vm._v(_vm._s(scope.row.data2))])]
      }
    }])
  })], 1)], 1), _c('div', {
    staticClass: "title-text",
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_vm._v("三、咨询、投诉渠道")]), _c('div', {
    staticClass: "title-content"
  }, [_vm._v("3.1 八戒小贷咨询、投诉渠道")]), _c('div', {
    staticClass: "title-content"
  }, [_vm._v("官方网站："), _c('a', {
    attrs: {
      "href": "https://www.jr-zbj.com",
      "target": "_blank"
    }
  }, [_vm._v("www.jr-zbj.com")]), _vm._v("（工作日：09：00-18：00）；")]), _c('div', {
    staticClass: "title-content"
  }, [_vm._v("邮箱："), _c('a', {
    attrs: {
      "href": "mailto:bjxd@bajiegroup.com"
    }
  }, [_vm._v("bjxd@bajiegroup.com")]), _vm._v("（工作日：09：00-18：00）；")]), _c('div', {
    staticClass: "title-content"
  }, [_vm._v("电话：023-88392602（工作日：09：00-18：00）。")]), _c('div', {
    staticClass: "title-content"
  }, [_vm._v("3.2 区级监管机构投诉渠道")]), _c('div', {
    staticClass: "title-content"
  }, [_vm._v("区级监管部门：重庆市两江新区现代服务业局；")]), _c('div', {
    staticClass: "title-content"
  }, [_vm._v("电话023-65869288(工作日：9:00-12:30,14:00-18:00)；")]), _c('div', {
    staticClass: "title-content"
  }, [_vm._v("联络地址：重庆两江新区金渝大道66号金山大厦。")]), _c('div', {
    staticClass: "title-content"
  }, [_vm._v("如果您对我们的产品或是服务有任何意见、建议，欢迎随时与我们联系！")])])])])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-028422e4", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-028422e4","preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/@zbj/vue-mixin-loader?{"mixinPath":"D://zhubajie//Project//nodejs-zbjfins-web//app//resource//global//css//mixin//mixin.less"}!./app/resource/components/c-footer/discloseDialog.vue
// module id = 1180
// module chunks = 2